import type { ContractSchema } from '@libs/data-access/entities'

import { CONTRACT_TYPES_WITH_NO_RCR } from '../index'

type Params = {
  currentContract: ContractSchema
  fullTimeThreshold: number
  shouldShowRCRForPartTime: boolean
}
export const hasCompensatoryCounterAccess = (
  currentContract,
  fullTimeThreshold,
  shouldShowRCRForPartTime
): Params =>
  Boolean(fullTimeThreshold) &&
  !currentContract?.daily_worker &&
  !CONTRACT_TYPES_WITH_NO_RCR.includes(currentContract?.contract_type) &&
  currentContract?.contract_type !== null &&
  (shouldShowRCRForPartTime ||
    currentContract?.contract_time >= fullTimeThreshold)
